import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";

import * as modelHelper from "../../../../helpers/modelHelper";
import * as formatHelper from "../../../../helpers/formatHelper";

import Modal from "../../../global/generic/Modal";
import CloseButton from "../../../global/generic/CloseButton";
import Button, {BUTTON_SMALL} from "../../../global/generic/Button";
import SpectroMeasureButton from "../../../global/spectro/SpectroMeasureButton";
import SpectroCalibrateButton from "../../../global/spectro/SpectroCalibrateButton";

import imgSearch from "../../../../resources/img/svgicons/search.svg";

class MatchingMeasurementModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSelectColorClick = () => {
        this.props.dispatchOpenSearchModalAction(
            this.props.tabId,
            this.props.params.title,
            this.props.params.searchCallback
        );
        this.props.dispatchCloseModalAction();
    };

    getSearchButton = () => {
        if (!this.props.params.searchButton) {
            return null;
        }

        return (
            <Button
                svgBefore={imgSearch}
                label={<Translate value="general.select" />}
                className="margin-right-auto"
                size={BUTTON_SMALL}
                onClick={this.handleSelectColorClick}
            />
        );
    };

    getLabData = () => {
        if (!Array.isArray(this.props.params.result.lab) || this.props.params.result.lab.length !== 3) {
            return [];
        }

        let lab = [];

        lab.push(
            <div key="1" className="col-4">
                <div className="color-primary pull-left padding-right-5">L:</div>
                <div className="pull-left">{formatHelper.formatDecimal(this.props.params.result.lab[0])}</div>
            </div>
        );

        lab.push(
            <div key="2" className="col-4">
                <div className="color-primary pull-left padding-right-5">A:</div>
                <div className="pull-left">{formatHelper.formatDecimal(this.props.params.result.lab[1])}</div>
            </div>
        );

        lab.push(
            <div key="3" className="col-4">
                <div className="color-primary pull-left padding-right-5">B:</div>
                <div className="pull-left">{formatHelper.formatDecimal(this.props.params.result.lab[2])}</div>
            </div>
        );

        return lab;
    };

    getRgbData = () => {
        if (!Array.isArray(this.props.params.result.rgb) || this.props.params.result.rgb.length !== 3) {
            return [];
        }

        let rgb = [];

        rgb.push(
            <div key="4" className="col-4">
                <div className="color-primary pull-left padding-right-5">R:</div>
                <div className="pull-left">{this.props.params.result.rgb[0]}</div>
            </div>
        );

        rgb.push(
            <div key="5" className="col-4">
                <div className="color-primary pull-left padding-right-5">G:</div>
                <div className="pull-left">{this.props.params.result.rgb[1]}</div>
            </div>
        );

        rgb.push(
            <div key="6" className="col-4">
                <div className="color-primary pull-left padding-right-5">B:</div>
                <div className="pull-left">{this.props.params.result.rgb[2]}</div>
            </div>
        );

        return rgb;
    };

    getXyzData = () => {
        if (!Array.isArray(this.props.params.result.xyz) || this.props.params.result.xyz.length !== 3) {
            return [];
        }

        let xyz = [];

        xyz.push(
            <div key="7" className="col-4">
                <div className="color-primary pull-left padding-right-5">X:</div>
                <div className="pull-left">{formatHelper.formatDecimal(this.props.params.result.xyz[0])}</div>
            </div>
        );

        xyz.push(
            <div key="8" className="col-4">
                <div className="color-primary pull-left padding-right-5">Y:</div>
                <div className="pull-left">{formatHelper.formatDecimal(this.props.params.result.xyz[1])}</div>
            </div>
        );

        xyz.push(
            <div key="9" className="col-4">
                <div className="color-primary pull-left padding-right-5">Z:</div>
                <div className="pull-left">{formatHelper.formatDecimal(this.props.params.result.xyz[2])}</div>
            </div>
        );

        return xyz;
    };

    getHexData = () => {
        return (
            <div className="col-4">
                <div className="pull-left">{this.props.params.result.rgbHex}</div>
            </div>
        );
    };

    getContent = () => {
        if (this.props.params.result) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <div className="col-5">
                        <div className="row col-12 flex flex-wrap margin-bottom-12">
                            <div className="pull-left color-primary col-12">Lab D65/10: </div>
                            {this.getLabData()}
                        </div>
                        <div className="row col-12 flex flex-wrap margin-bottom-12">
                            <div className=" pull-left color-primary col-12">XYZ D65/10: </div>
                            {this.getXyzData()}
                        </div>
                        <div className="row col-12 flex flex-wrap margin-bottom-12">
                            <div className="pull-left color-primary col-12">RGB (sRGB):</div>
                            {this.getRgbData()}
                        </div>
                        <div className="row col-12 flex flex-wrap margin-bottom-12">
                            <div className=" pull-left color-primary col-12">RGB (hex):</div>
                            {this.getHexData()}
                        </div>
                    </div>
                    <div className="col-7">
                        <span className="color-primary">
                            <Translate value="general.colorPreview" />:
                        </span>
                        <div
                            className="width-100 height-100 margin-bottom-12 margin-top-5 box-shadow"
                            style={{backgroundColor: this.props.params.result.rgbHex, height: "85%"}}
                        />
                    </div>
                </React.Fragment>,
                "flex flex-wrap "
            );
        }
        return modelHelper.buildModalSection(
            <React.Fragment>
                <span>No data found</span>
            </React.Fragment>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <SpectroMeasureButton
                    tabId={this.props.tabId}
                    className={this.props.params.searchButton ? null : "margin-right-auto"}
                    size={BUTTON_SMALL}
                    callback={this.props.params.spectroCallback}
                />
                <SpectroCalibrateButton
                    size={BUTTON_SMALL}
                    className={this.props.params.searchButton ? null : "margin-right-auto"}
                />
                {this.getSearchButton()}
                <CloseButton className="margin-left-auto" onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.props.params.title + this.props.params.subject)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "60%", height: "50%"}}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MATCHING_MEASUREMENT_MODAL));
        },
        dispatchOpenSearchModalAction: (tabId, title, callback) => {
            dispatch(
                navigationActions.openModalWithParams(tabId, componentTypes.SEARCH_IN_STANDARD_FORMULAS, {
                    title: title,
                    callback: callback
                })
            );
        }
    };
};

export default MatchingMeasurementModal = connect(mapStoreToProps, mapDispatchToProps)(MatchingMeasurementModal);
